var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "om-wrap" },
    [
      _c("div", { staticClass: "om-toolbar" }, [
        _c(
          "label",
          {
            staticClass: "om-toggle",
            class: { "om-toggle--on": _vm.editfield.show_value }
          },
          [
            _c("el-checkbox", {
              model: {
                value: _vm.editfield.show_value,
                callback: function($$v) {
                  _vm.$set(_vm.editfield, "show_value", $$v)
                },
                expression: "editfield.show_value"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Values")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "om-toggle",
            class: { "om-toggle--on": _vm.editfield.sync_value }
          },
          [
            _c("el-checkbox", {
              model: {
                value: _vm.editfield.sync_value,
                callback: function($$v) {
                  _vm.$set(_vm.editfield, "sync_value", $$v)
                },
                expression: "editfield.sync_value"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Auto-sync")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "om-toggle",
            class: { "om-toggle--on": _vm.editfield.calc_value }
          },
          [
            _c("el-checkbox", {
              model: {
                value: _vm.editfield.calc_value,
                callback: function($$v) {
                  _vm.$set(_vm.editfield, "calc_value", $$v)
                },
                expression: "editfield.calc_value"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Calc")])
          ],
          1
        ),
        _vm._v(" "),
        _vm.editfield.image
          ? _c(
              "label",
              {
                staticClass: "om-toggle",
                class: { "om-toggle--on": _vm.editfield.photo_value }
              },
              [
                _c("el-checkbox", {
                  model: {
                    value: _vm.editfield.photo_value,
                    callback: function($$v) {
                      _vm.$set(_vm.editfield, "photo_value", $$v)
                    },
                    expression: "editfield.photo_value"
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Photo")])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "om-col-headers" }, [
        _c("span", { staticClass: "om-col-headers__spacer" }),
        _vm._v(" "),
        _c("span", [_vm._v("Label")]),
        _vm._v(" "),
        _vm.editfield.show_value ? _c("span", [_vm._v("Value")]) : _vm._e(),
        _vm._v(" "),
        _vm.editfield.calc_value ? _c("span", [_vm._v("Calc")]) : _vm._e(),
        _vm._v(" "),
        _vm.editfield.photo_value && _vm.editfield.image
          ? _c("span", [_vm._v("Photo")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "om-list option-field-swapper" },
        _vm._l(_vm.options, function(option, index) {
          return _c("li", { key: index, staticClass: "om-row" }, [
            _vm._m(0, true),
            _vm._v(" "),
            _c("span", { staticClass: "om-row__selector" }, [
              _vm.field.is_multiple
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected,
                        expression: "selected"
                      }
                    ],
                    staticClass: "om-check",
                    attrs: { type: "checkbox" },
                    domProps: {
                      value: option.value,
                      checked: Array.isArray(_vm.selected)
                        ? _vm._i(_vm.selected, option.value) > -1
                        : _vm.selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = option.value,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selected = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selected = $$c
                        }
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected,
                        expression: "selected"
                      }
                    ],
                    staticClass: "om-check",
                    attrs: { type: "radio" },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.selected, option.value)
                    },
                    on: {
                      change: function($event) {
                        _vm.selected = option.value
                      }
                    }
                  })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "om-row__label" },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "Label" },
                  on: {
                    input: function($event) {
                      return _vm.set_option_value(index, option.label)
                    }
                  },
                  model: {
                    value: option.label,
                    callback: function($$v) {
                      _vm.$set(option, "label", $$v)
                    },
                    expression: "option.label"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.editfield.show_value
              ? _c(
                  "div",
                  { staticClass: "om-row__value" },
                  [
                    _c("el-input", {
                      attrs: { size: "small", placeholder: "value" },
                      model: {
                        value: option.value,
                        callback: function($$v) {
                          _vm.$set(option, "value", $$v)
                        },
                        expression: "option.value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editfield.calc_value
              ? _c(
                  "div",
                  { staticClass: "om-row__value" },
                  [
                    _c("el-input", {
                      attrs: { size: "small", placeholder: "0" },
                      model: {
                        value: option.calc_value,
                        callback: function($$v) {
                          _vm.$set(option, "calc_value", $$v)
                        },
                        expression: "option.calc_value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editfield.photo_value
              ? _c("div", { staticClass: "om-row__photo" }, [
                  _c(
                    "div",
                    {
                      staticClass: "om-photo-thumb",
                      on: {
                        click: function($event) {
                          return _vm.initUploader(option)
                        }
                      }
                    },
                    [
                      option.photo
                        ? _c("img", { attrs: { src: option.photo } })
                        : _c("i", {
                            staticClass:
                              "el-icon-picture-outline om-photo-thumb__icon"
                          })
                    ]
                  ),
                  _vm._v(" "),
                  option.photo
                    ? _c("i", {
                        staticClass: "el-icon-close om-photo-remove",
                        on: {
                          click: function($event) {
                            option.photo = ""
                          }
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "om-row__actions" }, [
              _c("i", {
                staticClass: "el-icon-circle-plus om-btn-add",
                attrs: { title: "Add option" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.add_option($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.options.length > 1
                ? _c("i", {
                    staticClass: "el-icon-remove om-btn-del",
                    attrs: { title: "Remove" },
                    on: {
                      click: function($event) {
                        return _vm.delete_option(index)
                      }
                    }
                  })
                : _vm._e()
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "om-footer" }, [
        _c(
          "button",
          {
            staticClass: "om-btn om-btn--ghost",
            on: {
              click: function($event) {
                return _vm.initBulkEdit()
              }
            }
          },
          [
            _c("i", { staticClass: "el-icon-edit-outline" }),
            _vm._v(" Bulk Edit\n    ")
          ]
        ),
        _vm._v(" "),
        !_vm.field.is_multiple && _vm.selected.length > 0
          ? _c(
              "button",
              {
                staticClass: "om-btn om-btn--danger",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.clear_selection($event)
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-close" }),
                _vm._v(" Clear Selection\n    ")
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.bulkEditVisible,
            "custom-class": "ctm-bulk-dialog",
            width: "500px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.bulkEditVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ctm-bulk-dialog__head",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("div", { staticClass: "ctm-bulk-dialog__head-icon" }, [
                _c("i", { staticClass: "el-icon-edit-outline" })
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "ctm-bulk-dialog__head-title" }, [
                  _vm._v("Bulk Edit Options")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ctm-bulk-dialog__head-sub" }, [
                  _vm._v("\n          One option per line  · \n          "),
                  _c("code", [_vm._v("Label")]),
                  _vm._v(" or "),
                  _c("code", [_vm._v("Label:value")])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ctm-bulk-dialog__body" }, [
            Object.keys(_vm.editor_options).length
              ? _c("div", { staticClass: "ctm-bulk-dialog__presets" }, [
                  _c(
                    "div",
                    { staticClass: "ctm-bulk-dialog__presets-header" },
                    [
                      _c("i", { staticClass: "el-icon-collection-tag" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Quick presets")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ctm-bulk-dialog__preset-list" },
                    _vm._l(_vm.editor_options, function(opts, name) {
                      return _c(
                        "button",
                        {
                          key: name,
                          class: [
                            "ctm-preset-btn",
                            {
                              "ctm-preset-btn--active":
                                _vm.activePreset === name
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.setOptions(opts, name)
                            }
                          }
                        },
                        [_vm._v(_vm._s(name))]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-bulk-dialog__editor" }, [
              _c("div", { staticClass: "ctm-bulk-dialog__editor-bar" }, [
                _c("span", { staticClass: "ctm-bulk-dialog__editor-label" }, [
                  _vm._v("Options")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ctm-bulk-dialog__editor-count" }, [
                  _vm._v(
                    _vm._s(_vm.lineCount) +
                      " line" +
                      _vm._s(_vm.lineCount !== 1 ? "s" : "")
                  )
                ])
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value_key_pair_text,
                    expression: "value_key_pair_text"
                  }
                ],
                staticClass: "ctm-bulk-dialog__textarea",
                attrs: {
                  placeholder: "Option 1&#10;Option 2:value2&#10;Option 3",
                  spellcheck: "false"
                },
                domProps: { value: _vm.value_key_pair_text },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.value_key_pair_text = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "ctm-bulk-dialog__hint" }, [
              _c("i", { staticClass: "el-icon-info" }),
              _vm._v(
                "\n        Lines without a colon use the label as the value. Blank lines are ignored.\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ctm-bulk-dialog__footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "om-btn om-btn--ghost",
                  on: {
                    click: function($event) {
                      _vm.bulkEditVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "om-btn om-btn--primary",
                  on: {
                    click: function($event) {
                      return _vm.confirmBulkEdit()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-check" }),
                  _vm._v(" Apply\n      ")
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "om-row__drag" }, [
      _c("i", { staticClass: "el-icon-more om-drag-icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }